var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26861",
    "data-name": "Group 26861",
    transform: "translate(-313 -260)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_37779",
    "data-name": "Path 37779",
    transform: "translate(313 260)",
    fill: "#fff",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16 31.5 C 11.85980033874512 31.5 7.967410087585449 29.88772010803223 5.039840221405029 26.96015930175781 C 2.112279891967773 24.03259086608887 0.5 20.14019966125488 0.5 16 C 0.5 11.85980033874512 2.112279891967773 7.967410087585449 5.039840221405029 5.039840221405029 C 7.967410087585449 2.112279891967773 11.85980033874512 0.5 16 0.5 C 20.14019966125488 0.5 24.03259086608887 2.112279891967773 26.96015930175781 5.039840221405029 C 29.88772010803223 7.967410087585449 31.5 11.85980033874512 31.5 16 C 31.5 20.14019966125488 29.88772010803223 24.03259086608887 26.96015930175781 26.96015930175781 C 24.03259086608887 29.88772010803223 20.14019966125488 31.5 16 31.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16 1 C 11.99334907531738 1 8.226520538330078 2.560270309448242 5.393400192260742 5.393400192260742 C 2.560270309448242 8.226520538330078 1 11.99334907531738 1 16 C 1 20.00664901733398 2.560270309448242 23.77347946166992 5.393400192260742 26.60659980773926 C 8.226520538330078 29.43972969055176 11.99334907531738 31 16 31 C 20.00664901733398 31 23.77347946166992 29.43972969055176 26.60659980773926 26.60659980773926 C 29.43972969055176 23.77347946166992 31 20.00664901733398 31 16 C 31 11.99334907531738 29.43972969055176 8.226520538330078 26.60659980773926 5.393400192260742 C 23.77347946166992 2.560270309448242 20.00664901733398 1 16 1 M 16 0 C 24.8365592956543 0 32 7.163440704345703 32 16 C 32 24.8365592956543 24.8365592956543 32 16 32 C 7.163440704345703 32 0 24.8365592956543 0 16 C 0 7.163440704345703 7.163440704345703 0 16 0 Z",
    stroke: "none",
    fill: "#1c1c1c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-add",
    "data-name": "Icon material-add",
    d: "M19.5,14.357H14.357V19.5H12.643V14.357H7.5V12.643h5.143V7.5h1.714v5.143H19.5Z",
    transform: "translate(315.5 262.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderPlus);
export default __webpack_public_path__ + "static/media/slider-plus.b6cd89ee9808c0453f2ee5a5d441e838.svg";
export { ForwardRef as ReactComponent };